<template>
  <div class="frame15_body">
    <div class="frame15">
      <div class="frame15_top">
        现金流量
        <img
          src="../../../../public/img/shares_Info/close.png"
          alt=""
          @click="frame15_close"
        />
      </div>
      <div class="frame15_content">
        <div class="frame15_content_title">净现比</div>
        <div class="frame15_content_text">
          【释义】：净利润现金比率的简称，是指企业本期经营活动产生的现金净流量与净利润之间的比率关系。一般情况下，比率越大，企业盈利质量越高。
        </div>
        <div class="frame15_content_text">【算法】：净现比=经营活动产生的现金流量净额/归属于母公司所有者的净利润*100%</div>
        <div class="frame15_content_text">【单位】：%</div>
      </div>
      <div class="frame15_content">
        <div class="frame15_content_title">收现比</div>
        <div class="frame15_content_text">
          【释义】：是指在一定时期内企业所实现的销售收入中实际收到的现金比例。该数值等于1，代表企业在一段时期的销售全部收现，企业无风险；数值大于1，企业不仅已将本时期的销售全部收现，还回笼了部分以往时期的欠款，为高质量收益；数值小于1，销售还未全部收现或者以非现金的形式回笼，面临一定风险。收现比以1为界限，数值越大越有利于公司发展。
        </div>
        <div class="frame15_content_text">【算法】：收现比=销售商品提供劳务收到的现金/营业务收入*100% </div>
        <div class="frame15_content_text">【单位】：%</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    frame15_close() {
      this.$emit("frame15_close");
    },
  },
};
</script>

<style scoped>
.frame15_body {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: scroll;
  z-index: 9999999;
}
.frame15 {
  width: 448px;
  height: 620px;
  background-color: #ffffff;
  box-shadow: 0px 2px 51px 6px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  padding: 30px 36px;
  margin: 50px auto;
  margin-top: 200px;
}
.frame15_top {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #f4f4f4;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.frame15_content {
  margin-top: 28px;
}
.frame15_top img {
  width: 19px;
  float: right;
  margin-top: 3px;
}
.frame15_content_title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
}
.frame15_content_text {
  font-size: 16px;
  font-weight: bold;
  color: #666666;
  line-height: 30px;
}
</style>